import { CheckboxGroupContextShape } from "types";
import { setupContext } from "context/useCSContext";

export const Context = setupContext<CheckboxGroupContextShape>("CheckboxGroupContext");
